import { cookiesSupported } from "../utilities";

let _csrfTokenPromise = cookiesSupported
  ? null
  : Promise.resolve("cookies-disabled");

/// Fetches CSRF token for real. The function fetchCSRFToken memoises this.
async function requestCSRFToken() {
  const timestamp = Date.now().toString();
  const response = await fetch(`/csrf?t=${timestamp}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
  if (!response.ok) {
    throw new Error("failed to fetch CSRF token", response);
  }
  const data = await response.json();
  return data.token;
}

/**
 * Fetch CSRF token over AJAX
 *
 * Restricts to a single AJAX call per page load, will resolve with the token
 * whenever it’s returned
 *
 * @return {Promise}
 */
export async function fetchCSRFToken() {
  if (!_csrfTokenPromise) {
    _csrfTokenPromise = requestCSRFToken();
  }

  return await _csrfTokenPromise;
}

/**
 * Viewloader compatible function for generating CSRF tags
 * @param  {Element} el Element to append CSRF token to
 */
export default function csrfTag(el) {
  fetchCSRFToken().then(csrfToken => {
    if (el.nodeName === "META") {
      el.setAttribute("content", csrfToken);
    } else {
      el.setAttribute("value", csrfToken);
    }
  });
}
